import { render, staticRenderFns } from "./Ouverture.vue?vue&type=template&id=51d30f28"
import script from "./Ouverture.vue?vue&type=script&lang=js"
export * from "./Ouverture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports